import { Component, OnInit, Inject } from "@angular/core";
import { FormGroup, FormBuilder } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DialogSelectItemComponent } from "../dialog-select-item/dialog-select-item.component";

@Component({
  selector: "app-dialog-orden-liquidacion",
  templateUrl: "./dialog-orden-liquidacion.component.html",
  styleUrls: ["./dialog-orden-liquidacion.component.css"],
})
export class DialogOrdenLiquidacionComponent implements OnInit {
  ordenLiquidacionGroup: FormGroup;

  //#############################ATENCION SI SE MODIFICA EL NOMBRE DE ALGUN ORDEN DE LIQUIDACION SE DEBE MODIFICAR TAMBIEN EN CREACION Y EDICION DE TARIFAS
  ordenesLiquidacion = [
    "LIQUIDACION SOBRE BASE",
    "LIQUIDACION DESPUES DE BASE",
    //"LIQUIDACION ESPECIAL",
  ];
  //#############################ATENCION SI SE MODIFICA EL NOMBRE DE ALGUN ORDEN DE LIQUIDACION SE DEBE MODIFICAR TAMBIEN EN CREACION Y EDICION DE TARIFAS

  idTarifa: any;

  constructor(
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public dataDialog: any,
    private dialogRef: MatDialogRef<DialogSelectItemComponent>
  ) {
    this.idTarifa = dataDialog;
    this.ordenLiquidacionGroup = this.fb.group({
      orden: [""],
    });
  }

  ngOnInit() {}

  cerrar(event) {
    let data = "";
    if (event) {
      data = event.value;
    }

    console.log(data);

    this.dialogRef.close({ idTarifa: this.idTarifa, data: data });
  }
}
